import { render } from "./customer-popup.vue?vue&type=template&id=39d091a9"
import script from "./customer-popup.vue?vue&type=script&lang=js"
export * from "./customer-popup.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Cater-Frontend\\cater\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__